import styled from 'styled-components';
import { CalciteTextArea } from 'components/Calcite';

export const StyledTextField = styled(CalciteTextArea)`
  --calcite-sans-family: ${({ theme }) => theme.font.codeFamily};
`;
